import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import SelectQuestionComponent from "./SelectQuestionComponent";
import MultiSelectQuestionComponent from "./MultiSelectQuestionComponent";
import NumberQuestionComponent from "./NumberQuestionComponent";
import { useFormContext } from "react-hook-form";

function GetQuestionForm({ questions, setValue }) {
  const { reset } = useFormContext();
  const [savedAnswers, setSavedAnswers] = useState(null);

  useEffect(() => {
    // Retrieve saved answers from session storage
    const savedAnswers = sessionStorage.getItem("userAnswers");
    if (savedAnswers) {
      const parsedAnswers = JSON.parse(savedAnswers);
      setSavedAnswers(parsedAnswers); // Store the answers in state
    }
  }, []);

  useEffect(() => {
    // Reset the form only when savedAnswers and questions are available
    if (savedAnswers && questions?.length > 0) {
      reset(savedAnswers); // Prefill the form with saved values
      setValue("role", savedAnswers?.role); // Set the role field value
      setValue("location", savedAnswers?.location); // Set the location field value
    }
  }, [savedAnswers, reset]);

  return (
    <>
      {questions?.map((question, index) => {
        if (!question?.isSuggested && !question?.hideQuestion) {
          switch (question.type) {
            case "number":
              return (
                <Grid item xs={12} md={12} lg={8} key={index}>
                  <NumberQuestionComponent
                    question={question}
                    questionsObject={questions}
                  />
                </Grid>
              );
            case "select":
              return (
                <Grid item xs={12} md={12} lg={8} key={index}>
                  <SelectQuestionComponent
                    question={question}
                    questionsObject={questions}
                  />
                </Grid>
              );
            case "multiSelect":
              return (
                <>
                  {question?.skillMultiselect === true ? (
                    <>
                      {/* <SkillMultiSelectQuestionComponent question={question} key={index} /> */}
                    </>
                  ) : question?.dynamicMultiSelect ? (
                    ""
                  ) : (
                    <Grid item xs={12} md={12} lg={4} key={index}>
                      {/* <DynamicMultiSelectQuestionComponent key={index} question={question} /> */}
                      <MultiSelectQuestionComponent question={question} />
                    </Grid>
                  )}
                </>
              );
            default:
              return null;
          }
        }
        return null;
      })}
    </>
  );
}

export default GetQuestionForm;
